module.exports = __webpack_public_path__ + "a627f46960016409ae2ad83aea5ad271.MP3";